var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        ref: _vm.playerWrapId,
        staticStyle: {
          width: "100%",
          height: "calc(100vh - 70px - 60px - 40px)",
          "max-height": "500px"
        },
        attrs: { id: _vm.playerWrapId }
      },
      [
        _c("volume", {
          ref: "volume",
          staticStyle: {
            display: "inline-block",
            position: "absolute",
            right: "82px",
            top: "50%",
            transform: "translateY(-36%)"
          },
          attrs: { player: _vm.AliyunPlayer }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.isWaterMark
      ? _c(
          "div",
          {
            ref: "waterMark",
            staticClass: "waterMark",
            style: { fontSize: _vm.waterMarkFontSize }
          },
          [
            _vm._l(3, function(n) {
              return _c(
                "div",
                { key: n, staticClass: "item" },
                _vm._l(5, function(n) {
                  return _c(
                    "div",
                    {
                      key: n,
                      staticClass: "content",
                      style: { opacity: n % 2 == 0 ? 0.2 : 0.5 }
                    },
                    [
                      _c("span", { staticClass: "name" }, [
                        _vm._v(_vm._s(_vm.name))
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "phone" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("showPhoneOrEmail")(_vm.phone, _vm.email)
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("span", { staticClass: "time" }, [
                        _vm._v(_vm._s(_vm.loginTime))
                      ])
                    ]
                  )
                }),
                0
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-73686e96", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-73686e96","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video_player.vue
// module id = null
// module chunks = 